import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFeaturedPublishedBlogPosts } from "../../../controllers/blogController";
import { formatDate } from "../../../utils/dateFormate";

const FeaturedBlogPostsList = () => {
  const [featuredPosts, setFeaturedPosts] = useState([]);

  const getPostsData = async () => {
    const FPosts = await getFeaturedPublishedBlogPosts();
    if (FPosts.length > 0) {
      setFeaturedPosts(FPosts);
    }
  };
  useEffect(() => {
    getPostsData();
  }, []);

  return (
    <section className="featured-blog">
      <div className="featured-blog__top">
        <div className="featured-blog__top__left w-60">
          <h2>Featured Blog</h2>
        </div>
      </div>

      <ul className="blog-posts-list">
        {featuredPosts &&
          featuredPosts.reverse().map((post, index) => {
            if (post.isFeatured && index < 3) {
              // 1. Safely parse stringified JSON fields
              const imageObj =
                typeof post.image === "string"
                  ? JSON.parse(post.image)
                  : post.image;
              const authorObj =
                typeof post.author === "string"
                  ? JSON.parse(post.author)
                  : post.author;

              // 2. Safely calculate the image source
              const imgSrc = imageObj?.src
                ? imageObj.src.startsWith("http")
                  ? imageObj.src
                  : `/${imageObj.src}`
                : "/assets/images/default-placeholder.jpg";
              return (
                <li key={post.id} className="blog-posts-list__post">
                  <img
                    loading="lazy"
                    src={imgSrc}
                    alt={post.image?.alt || "Blog post image"}
                    title={post.image?.alt || "Blog post"}
                    width={100}
                    height={100}
                    className="blog-posts-list__post-image"
                  />
                  <div className="blog-posts-list__post-content">
                    <h2 className="blog-posts-list__post-content-title">
                      {post.title.length > 80
                        ? post.title.substring(0, 80) + "..."
                        : post.title}
                    </h2>
                    <p>{post.author.name}</p>
                    <p className="blog-posts-list__post-content-date">
                      {formatDate(post.date)}
                    </p>
                    <p
                      className="blog-posts-list__post-content-summary"
                      dangerouslySetInnerHTML={{
                        __html:
                          post.summary.length > 150
                            ? post.summary.substring(0, 150) + "..."
                            : post.summary,
                      }}
                    />
                    {/* Read more option updated for Content Best Practices (CBP) from read more to  */}
                    <Link
                      to={`/blog/${post.slug}`}
                      className="blog-posts-list__post-content-button"
                      aria-label={`Read more about ${post.title}`}
                    >
                      {/* Read more about {post.title.substring(0, 5)}... */}
                      Read more...
                    </Link>
                  </div>
                </li>
              );
            } else {
              return null;
            }
          })}
      </ul>
      <div className="courses__bottom w-100">
        <Link to="/blog">See All</Link>
      </div>
    </section>
  );
};

export default FeaturedBlogPostsList;
